import { useMemo } from 'react';
import { isResourcePartiallyLoaded } from '~/_shared/types/fetchableResource/fetchableResource.helpers';
import { usePlacesSearchResultsSelector } from '~/store/frontendState/places/places.selectors';
import { useMapSettingsPlacesSearchesSelector } from '~/store/mapSettings/places/mapSettingsPlaces.selectors';

export const usePlacesSearchResults = () => {
  const placesSearchResults = usePlacesSearchResultsSelector();
  const placesSearches = useMapSettingsPlacesSearchesSelector();

  return useMemo(() => {
    const removedPlacesBySearchId = new Map(
      placesSearches.map(search => [search.id, new Set(search.removedPlaces ?? [])])
    );

    const result = new Map(placesSearchResults);

    for (const [searchId, fetchableResult] of result) {
      if (!isResourcePartiallyLoaded(fetchableResult)) {
        continue;
      }

      const removedPlaces = removedPlacesBySearchId.get(searchId);
      if (!removedPlaces?.size) {
        continue;
      }

      result.set(searchId, {
        ...fetchableResult,
        value: {
          ...fetchableResult.value,
          items: fetchableResult.value.items.filter(place => !removedPlaces.has(place.id)),
        },
      });
    }

    return result;
  }, [placesSearchResults, placesSearches]);
};
